/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Client module `i18n` for the Caintra Connect frontend.
 * @module i18n
 *
 * Conventions:
 * - Keep components focused on rendering; move branching logic into hooks or utils.
 * - Prefer named exports for helpers and default exports for React components.
 * - Reuse shared validation, i18n, and API helpers from client/src/utils and logic/.
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: "es",
    debug: true,
    fallbackLng: "es",
    interpolation: {
      escapeValue: false,
    },
  });
export default i18n;
